import { render, staticRenderFns } from "./SiftText.vue?vue&type=template&id=1e16d8c1&scoped=true&"
import script from "./SiftText.vue?vue&type=script&lang=js&"
export * from "./SiftText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e16d8c1",
  null
  
)

export default component.exports